<div id="loadingScreen" *ngIf="savingInProgressScreen">
  <section class="vh-90">
    <div class="container py-5 h-100">
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-12 col-md-8 col-lg-6 col-xl-5">
          <div class="card shadow-2-strong" style="border-radius: 1rem;">
            <div class="card-body p-5 text-center">

              <h3 class="mb-5">Updating Server Data</h3>

              <div class="loading-container">
                <label>
                  <span class="spinner-border spinner-grow-sm"></span>
                  Saving data ...
                </label>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

